/**
 * Resolve a {@link DocLinkTarget} to a concrete href for the reader's locale.
 *
 * Internal doc links are locale-aware (a French reader's links stay in `/fr/docs`);
 * marketing-route links are now locale-prefixed too (the whole site is published
 * per-locale since GA-13 / ADR-0133); external links pass through verbatim.
 */
import { type Locale } from '@syncanix/shared';

import { localizedPath } from '@/i18n/locale-path';
// localeAlternates moved to the shared SEO module (site-wide since ADR-0133);
// re-exported here so existing docs importers keep resolving.
import { localeAlternates } from '@/lib/seo/locale-alternates';

import type { DocLinkTarget } from './content/types';

export { localeAlternates };

export interface ResolvedDocLink {
  readonly href: string;
  readonly external: boolean;
}

export function resolveDocLink(target: DocLinkTarget, locale: Locale): ResolvedDocLink {
  if ('docSlug' in target) {
    return { href: localizedPath(`/docs/${target.docSlug}`, locale), external: false };
  }
  if ('external' in target) {
    return { href: target.href, external: true };
  }
  return { href: localizedPath(target.path, locale), external: false };
}
